import { withTranslation } from '@application/i18n/with_translation';
import { UniversalConfig } from '@application/universal_config.service';
import { ButtonArrange, Flex, Form, useFormContext } from '@cellula/react';
import { TopBar } from '@component/top_bar.component';
import { RouterService } from '@cortex-shim/router.service';
import { DynamicForm } from '@feature/dynamic_form/dynamic_form.component';
import { FormWorker } from '@feature/dynamic_form/form_manager/form_worker';
import { FormOpportunity } from '@visiba/api-vcs-client-v2';
import { useResolve, useResolveController } from '@visiba/instantiation';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { AppointmentController } from '../view_appointment.controller';
import { BackgroundOutlet } from './_background_outlet';

interface SingleFormProps {
	worker: Readonly<FormWorker>;
}

export function SingleForm(props: SingleFormProps) {
	const controller = useResolveController(AppointmentController, '');

	useEffect(() => {
		const disposers = [
			props.worker.events.on('onCommit', () => {
				controller.changeForm(props.worker.opportunity);
				disposers.forEach((x) => x());
			}),
			props.worker.events.on('onAbort', () => {
				controller.changeForm(props.worker.opportunity);
				disposers.forEach((x) => x());
			}),
		];

		return () => {
			disposers.forEach((x) => x());
		};
	}, [controller, props.worker]);

	return (
		<BackgroundOutlet>
			<TopBar.Outlet />

			<Flex
				grow='1'
				style={{
					margin: '0 auto',
					width: '100%',
					maxWidth: '600px',
				}}
			>
				<DynamicForm.Root formWorker={props.worker}>
					<TopBarContent worker={props.worker} />

					<DynamicForm.Description />
					<DynamicForm.Content>
						<Flex grow={1} justify='flex-end'>
							<ButtonArrange>
								<Form.SubmitButton>{withTranslation('PW.Common.Next')}</Form.SubmitButton>
							</ButtonArrange>
						</Flex>
					</DynamicForm.Content>
				</DynamicForm.Root>
			</Flex>
		</BackgroundOutlet>
	);
}

interface TopBarContentProps {
	worker: Readonly<FormWorker>;
}

function TopBarContent(props: TopBarContentProps) {
	const controller = useResolveController(AppointmentController, '');
	const formContext = useFormContext();
	const _routerService = useResolve(RouterService);
	const universalConfig = useResolve(UniversalConfig);
	const { ticket } = useParams();

	function handleGoBackIntercept(event: Event) {
		event.preventDefault();
		event.stopImmediatePropagation();

		const isLastPage = props.worker.isFirstOrLastPage();
		if (!isLastPage) {
			props.worker.changePage('backwards', formContext?.control.getValues() ?? {});

			return;
		}

		const result = controller.getFormPosition(props.worker);
		if (result === -1) {
			const routeStr = universalConfig.alias + '/visits/video/' + (ticket ?? 'not_found');
			// routerService.navigateByUrl(routeStr);

			// Help me escape this hell.
			window.location.href = routeStr;
		} else {
			controller.changeFormByIndex(props.worker.opportunity, result);
		}
	}

	return (
		<TopBar.Content
			title={props.worker.header}
			goBack={props.worker.opportunity === FormOpportunity.AfterBooking ? !props.worker.isFirstPage() : true}
			goBackIntercept={handleGoBackIntercept}
		/>
	);
}
